module.exports = __webpack_public_path__ + "static/img/footer-logo-2.645027e1.png";